export default __webpack_public_path__ + "static/media/photo--lg--misc-2.47f3a78e.jpg";